module.exports = "/_next/static/images/DataCenters-f3cebc2b438ed2258d7ac3baa8a5febb.webp";